/* ==========================================================================
   Pila Configurator — pila-configurator.js
   Public API: pilaOpenConfigurator() / pilaCloseConfigurator()
   ========================================================================== */

/* ── ICONS — inline 24×24 stroke set matching the pila-icon-* assets
   (1.6px stroke, round caps/joins, currentColor). Single source of truth;
   the liquid option cards ship empty .option-icon divs and are filled from
   here on load, so the set only lives in one place. ── */
function pi(paths) {
  return '<svg class="pi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
}
const ICONS = {
  kitchen:   pi('<rect x="7" y="2.8" width="10" height="18.4" rx="2.2"/><path d="M7 9.8h10M9.6 5.4v1.8M9.6 12.6v2.6"/>'),
  office:    pi('<rect x="4.5" y="5" width="15" height="10" rx="1.6"/><path d="M2.5 18.5h19"/>'),
  living:    pi('<path d="M5 10.5V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2.5"/><path d="M2.5 13a2 2 0 0 1 4 0v1h11v-1a2 2 0 0 1 4 0v3a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2v-3z"/><path d="M5.5 19v1.5M18.5 19v1.5"/>'),
  bedroom:   pi('<path d="M2.5 18.5v-6a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v6"/><path d="M2.5 16.5h19"/><path d="M4.5 10.5V7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3.5"/><path d="M7 10.5V9a1.5 1.5 0 0 1 3 0v1.5"/>'),
  garage:    pi('<path d="M4.5 16.5H3v-4l1.6-4.8A2 2 0 0 1 6.5 6.3h11a2 2 0 0 1 1.9 1.4L21 12.5v4h-1.5"/><circle cx="7.5" cy="16.5" r="1.8"/><circle cx="16.5" cy="16.5" r="1.8"/><path d="M9.3 16.5h5.4M5 12.5h14"/>'),
  ac:        pi('<path d="M12 3v18M12 3l-2.2 2.2M12 3l2.2 2.2M12 21l-2.2-2.2M12 21l2.2-2.2M4.2 7.5l15.6 9M4.2 16.5l15.6-9M4.2 7.5l.8 3M4.2 16.5l3-.8M19.8 16.5l-.8-3M19.8 7.5l-3 .8"/>'),
  furnace:   pi('<path d="M12 2.8c.6 3.5 4.3 5.5 5.5 8.8a6 6 0 1 1-11.4.6C6.9 8.5 11.3 6.8 12 2.8z"/><path d="M12 20.8a2.8 2.8 0 0 1-2.8-2.8c0-1.7 1.7-2.4 2.8-4.2 1.1 1.8 2.8 2.5 2.8 4.2a2.8 2.8 0 0 1-2.8 2.8z"/>'),
  sump:      pi('<path d="M12 2.8S5.8 9.6 5.8 14.2a6.2 6.2 0 0 0 12.4 0C18.2 9.6 12 2.8 12 2.8z"/>'),
  aquarium:  pi('<path d="M6.8 12c2-3.1 4.9-4.7 8.2-4.7 2.4 0 4.6 1.7 5.9 4.7-1.3 3-3.5 4.7-5.9 4.7-3.3 0-6.2-1.6-8.2-4.7z"/><path d="M6.8 12 3.1 8.9v6.2L6.8 12z"/><path d="M16.9 10.9v.2"/>'),
  none:      pi('<path d="M4 12.5l5 5L20 6.5"/>'),
  seamless:  pi('<path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12L13 2z"/>'),
  solar:     pi('<circle cx="12" cy="12" r="4"/><path d="M12 2.5V5M12 19v2.5M2.5 12H5M19 12h2.5M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M19.1 4.9l-1.8 1.8M6.7 17.3l-1.8 1.8"/>'),
  rates:     pi('<path d="M4 15.5a8 8 0 1 1 16 0"/><path d="M12 15.5l3.6-4.6"/><path d="M4 19h16"/>'),
  fridge:    pi('<path d="M10 13.6V4.5a2 2 0 0 1 4 0v9.1a4.5 4.5 0 1 1-4 0z"/><path d="M12 10v6"/>'),
  smarthome: pi('<path d="M3.5 10.5 12 3l8.5 7.5"/><path d="M5.5 9.5V20h13V9.5"/><circle cx="12" cy="14.5" r="2"/>'),
  simplicity:pi('<path d="M9 3v4M15 3v4"/><path d="M6.5 7h11v3a5.5 5.5 0 0 1-11 0V7z"/><path d="M12 15.5V21"/>'),
  home:      pi('<path d="M3.5 10.5 12 3l8.5 7.5"/><path d="M5.5 9.5V20h13V9.5"/>'),
  wifi:      pi('<path d="M3 9.5a13.5 13.5 0 0 1 18 0"/><path d="M6.5 13a8.5 8.5 0 0 1 11 0"/><path d="M9.8 16.4a4 4 0 0 1 4.4 0"/><path d="M12 19.4v.2"/>'),
  tv:        pi('<rect x="3" y="5.5" width="18" height="12" rx="2"/><path d="M8.5 21h7"/>'),
  bulb:      pi('<path d="M9.5 18h5M10.5 21h3"/><path d="M12 3a6 6 0 0 1 3.5 10.9c-.8.6-1 1.4-1 2.1h-5c0-.7-.2-1.5-1-2.1A6 6 0 0 1 12 3z"/>'),
  wind:      pi('<path d="M12.8 19.6A2 2 0 1 0 14 16H2.5"/><path d="M17.5 8a2.5 2.5 0 1 1 2 4H2.5"/><path d="M9.8 4.4A2 2 0 1 1 11 8H2.5"/>'),
  door:      pi('<path d="M3 20V8.5L12 4l9 4.5V20"/><path d="M6.5 12h11M6.5 15.2h11M6.5 18.4h11"/>'),
  pin:       pi('<path d="M12 21.5S5 14.8 5 9.9a7 7 0 0 1 14 0c0 4.9-7 11.6-7 11.6z"/><circle cx="12" cy="10" r="2.5"/>'),
  spark:     pi('<path d="M12 3c.5 4 2.3 7 7.5 8.4-5.2 1.4-7 4.4-7.5 8.4-.5-4-2.3-7-7.5-8.4C9.7 10 11.5 7 12 3z"/>'),
  trash:     pi('<path d="M4 6.5h16"/><path d="M9.5 6.5V5a1.5 1.5 0 0 1 1.5-1.5h2A1.5 1.5 0 0 1 14.5 5v1.5"/><path d="M6 6.5l.8 12a2 2 0 0 0 2 1.9h6.4a2 2 0 0 0 2-1.9l.8-12"/><path d="M10 11v5.5M14 11v5.5"/>'),
};

/* ── CONSTANTS ── */
const ROOM_LABELS = {kitchen:'Kitchen',office:'Home Office',living:'Living Room',bedroom:'Bedroom',garage:'Garage'};
const ROOM_ICONS  = {kitchen:ICONS.kitchen,office:ICONS.office,living:ICONS.living,bedroom:ICONS.bedroom,garage:ICONS.garage};
const HD_LABELS   = {ac:'Window A/C',furnace:'Gas Furnace (120V)',sump:'Sump Pump (120V)',aquarium:'Aquarium'};
const HD_ICONS    = {ac:ICONS.ac,furnace:ICONS.furnace,sump:ICONS.sump,aquarium:ICONS.aquarium};
const PRIORITY_LABELS = {
  seamless:   'Automatic backup',
  solar:      'Solar optimization',
  rates:      'Utility optimization',
  fridge:     'Fridge anomaly detection',
  smarthome:  'Smart home integrations',
  simplicity: 'Expandability',
};
const PRIORITY_ICONS = {
  seamless:ICONS.seamless, solar:ICONS.solar, rates:ICONS.rates, fridge:ICONS.fridge, smarthome:ICONS.smarthome, simplicity:ICONS.simplicity
};

/* Fill the empty .option-icon divs from the icon set (liquid ships them empty
   so the icons live in exactly one place), and make the cards keyboard-operable. */
document.querySelectorAll('#pila-configurator .option-card').forEach(function(card) {
  const slot = card.querySelector('.option-icon');
  const icon = ICONS[card.dataset.value];
  if (slot && icon && !slot.firstChild) slot.innerHTML = icon;
  card.setAttribute('role', 'button');
  card.setAttribute('tabindex', '0');
  card.setAttribute('aria-pressed', 'false');
  card.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
  });
});

function syncPressed(scope) {
  document.querySelectorAll(scope + ' .option-card').forEach(c =>
    c.setAttribute('aria-pressed', c.classList.contains('selected')));
}
const COLORS      = ['white','black','silver','red'];
const COLOR_LABELS= {white:'White',black:'Black',silver:'Silver',red:'Red'};
const COLOR_BG    = {white:'#F0EEEB',black:'#2A2A2A',silver:'#D0D0D0',red:'#D94032'};
const MOUNTS      = [
  {value:'flat',  label:'Flat (default)', note:'No accessory needed'},
  {value:'stand', label:'Vertical Stand',  note:'+Stand Kit'},
  {value:'wall',  label:'Wall Mount',      note:'+Mount Kit'}
];
/* ── PRICE FALLBACKS ── */
const PRICE_BATTERY_FB   = 1299;
const PRICE_EXPANSION_FB = 1199;
const PRICE_STAND_FB     = 89;
const PRICE_WALL_FB      = 99;
const PRICE_FRIDGE_FB    = 79;

/* ── PRODUCT DATA — variant IDs hardcoded, prices refreshed from Shopify variant API ──
   To add accessory variant IDs: Shopify Admin → Products → [product] → variant → check URL
   e.g. /admin/products/10197546959170/variants/[VARIANT_ID_HERE]                        ── */
window.PILA_PRODUCTS = {
  battery: {
    white:  { id: 50606350270786, price: PRICE_BATTERY_FB, image: null },
    black:  { id: 50606350238018, price: PRICE_BATTERY_FB, image: null },
    silver: { id: 50606350303554, price: PRICE_BATTERY_FB, image: null },
    red:    { id: 50606350336322, price: PRICE_BATTERY_FB, image: null },
  },
  expansion: {
    white:  { id: 51766209249602, price: PRICE_EXPANSION_FB },
    black:  { id: 51766209216834, price: PRICE_EXPANSION_FB },
    silver: { id: 51766209282370, price: PRICE_EXPANSION_FB },
    red:    { id: 51766209315138, price: PRICE_EXPANSION_FB },
  },
  fridge: { id: null, price: PRICE_FRIDGE_FB },  /* TODO: replace null with variant ID */
  stand:  { id: null, price: PRICE_STAND_FB },   /* TODO: replace null with variant ID */
  wall:   { id: null, price: PRICE_WALL_FB },    /* TODO: replace null with variant ID */
};

/* Refresh prices + load accessory variant IDs + battery hero images from Shopify */
(function() {
  function fp(h) { return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }); }
  Promise.all([
    fetch('/variants/50606350270786.js').then(function(r) { return r.json(); }), // white  — ref price + image
    fetch('/variants/50606350238018.js').then(function(r) { return r.json(); }), // black  — image
    fetch('/variants/50606350303554.js').then(function(r) { return r.json(); }), // silver — image
    fetch('/variants/50606350336322.js').then(function(r) { return r.json(); }), // red    — image
    fetch('/variants/51766209249602.js').then(function(r) { return r.json(); }), // expansion ref price
    fp('fridge-kit'),
    fp('vertical-stand'),
    fp('wall-mount-bracket'),
  ]).then(function(res) {
    var white = res[0], black = res[1], silver = res[2], red = res[3];
    var bp = white.price / 100, ep = res[4].price / 100;
    var fridge = res[5], stand = res[6], wall = res[7];
    ['white','black','silver','red'].forEach(function(c) {
      window.PILA_PRODUCTS.battery[c].price   = bp;
      window.PILA_PRODUCTS.expansion[c].price = ep;
    });
    // Store variant hero images (featured_image.src from Shopify variant API)
    window.PILA_PRODUCTS.battery.white.image  = white.featured_image  ? white.featured_image.src  : null;
    window.PILA_PRODUCTS.battery.black.image  = black.featured_image  ? black.featured_image.src  : null;
    window.PILA_PRODUCTS.battery.silver.image = silver.featured_image ? silver.featured_image.src : null;
    window.PILA_PRODUCTS.battery.red.image    = red.featured_image    ? red.featured_image.src    : null;
    window.PILA_PRODUCTS.fridge = { id: fridge.variants[0].id, price: fridge.variants[0].price / 100 };
    window.PILA_PRODUCTS.stand  = { id: stand.variants[0].id,  price: stand.variants[0].price  / 100 };
    window.PILA_PRODUCTS.wall   = { id: wall.variants[0].id,   price: wall.variants[0].price   / 100 };
    console.log('Pila: products loaded', window.PILA_PRODUCTS);
  }).catch(function(e) { console.warn('Pila: product fetch error', e); });
}());

/* ── LIVE PRICE HELPERS ── */
function pPrice(color)    { return window.PILA_PRODUCTS?.battery?.[color]?.price   ?? PRICE_BATTERY_FB; }
function pExpPrice(color) { return window.PILA_PRODUCTS?.expansion?.[color]?.price ?? PRICE_EXPANSION_FB; }
function pStandPrice()    { return window.PILA_PRODUCTS?.stand?.price  ?? PRICE_STAND_FB; }
function pWallPrice()     { return window.PILA_PRODUCTS?.wall?.price   ?? PRICE_WALL_FB; }
function pFridgePrice()   { return window.PILA_PRODUCTS?.fridge?.price ?? PRICE_FRIDGE_FB; }

/* ── STATE ── */
const S = { rooms: new Set(), highdraw: new Set(), priorities: new Set(), batteries: [], upsellQty: 1, zip: '', grid: null };

/* ── PUBLIC API — mirrors pila-hero video modal pattern ──
   aria-hidden controls display; .is-open triggers CSS transitions for backdrop + panel ── */
function pilaOpenConfigurator() {
  var wrapper = document.getElementById('pila-configurator');
  if (!wrapper) return;
  wrapper.setAttribute('aria-hidden', 'false');
  ensureGridData(); // prefetch so the ZIP lookup is instant by the time it's typed
  // Re-resolve a restored ZIP once the grid data is in
  const zi = document.getElementById('zip-input');
  if (zi && zi.value.length === 5 && !S.grid) onZipInput(zi);
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      wrapper.classList.add('is-open');
    });
  });
  document.body.style.overflow = 'hidden';
  if (window.Intercom) window.Intercom('update', { hide_default_launcher: true });
}

function pilaCloseConfigurator() {
  var wrapper = document.getElementById('pila-configurator');
  if (!wrapper) return;
  wrapper.classList.remove('is-open');
  setTimeout(function() {
    wrapper.setAttribute('aria-hidden', 'true');
  }, 420);
  document.body.style.overflow = '';
  // if (window.Intercom) window.Intercom('update', { hide_default_launcher: false });
}

// Attach close listeners to backdrop and any [data-configurator-close] elements
document.querySelectorAll('[data-configurator-close]').forEach(function(el) {
  el.addEventListener('click', pilaCloseConfigurator);
});

/* ── NAV ── */
let cur = 'intro';
const FOOTER_SCREENS = new Set(['zip','step1','step2','step3']);
function goTo(id) {
  if (id === 'zip') ensureGridData();
  const a = document.getElementById('screen-' + cur);
  const b = document.getElementById('screen-' + id);
  if (!a || !b) return;
  a.classList.add('exit-left');
  setTimeout(()=>{ a.classList.remove('active','exit-left'); b.classList.add('active'); b.scrollTop = 0; }, 280);
  cur = id;
  document.querySelectorAll('#pila-configurator-panel .footer-set').forEach(f => f.classList.remove('visible'));
  if (FOOTER_SCREENS.has(id)) {
    const fs = document.getElementById('footer-' + id);
    if (fs) fs.classList.add('visible');
  }
}

/* ── SESSION PERSISTENCE ──
   Selections and ZIP survive a closed popup or a page navigation within the
   session, so nobody re-answers questions they already answered. Nothing is
   sent anywhere; sessionStorage clears when the tab closes. ── */
const PERSIST_KEY = 'pila-configurator-v1';
function saveSelections() {
  try {
    sessionStorage.setItem(PERSIST_KEY, JSON.stringify({
      rooms: [...S.rooms], highdraw: [...S.highdraw], priorities: [...S.priorities], zip: S.zip,
    }));
  } catch (e) { /* storage unavailable — fine, just no resume */ }
}
function restoreSelections() {
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(PERSIST_KEY)); } catch (e) { return; }
  if (!saved) return;
  (saved.rooms || []).forEach(v => S.rooms.add(v));
  (saved.highdraw || []).forEach(v => S.highdraw.add(v));
  (saved.priorities || []).forEach(v => S.priorities.add(v));
  document.querySelectorAll('#pila-configurator .option-card').forEach(c => {
    const v = c.dataset.value;
    if (S.rooms.has(v) || S.highdraw.has(v) || S.priorities.has(v)) c.classList.add('selected');
    c.setAttribute('aria-pressed', c.classList.contains('selected'));
  });
  document.getElementById('next-step1').disabled = S.rooms.size === 0;
  document.getElementById('next-step2').disabled = S.highdraw.size === 0;
  document.getElementById('next-step3').disabled = S.priorities.size === 0;
  document.getElementById('edu-rooms').classList.toggle('visible', S.rooms.size > 0);
  if (saved.zip && saved.zip.length === 5) {
    const zi = document.getElementById('zip-input');
    if (zi) zi.value = saved.zip;
    S.zip = saved.zip; // grid data re-resolves on open via ensureGridData
  }
}
restoreSelections();

/* ── STEP 0: ZIP / GRID LOOKUP ──
   Fully client-side: the same packed ZIP→county table and county scorecard
   the /pages/grid-map page ships. Nothing typed here leaves the browser. ── */
let GRID_ZIPS = null, GRID_SC = null, gridFetch = null;

function ensureGridData() {
  const urls = window.PILA_GRID_DATA_URLS;
  if (gridFetch || !urls) return;
  gridFetch = Promise.all([
    fetch(urls.zips, { credentials: 'omit' }).then(r => r.json()),
    fetch(urls.scorecard, { credentials: 'omit' }).then(r => r.json()),
  ]).then(([zips, sc]) => { GRID_ZIPS = zips; GRID_SC = sc; })
    .catch(e => { console.warn('Pila: grid data fetch failed', e); gridFetch = null; });
}

// Binary search over the packed string of sorted 10-char records (zip+fips).
function countyForZip(zip) {
  if (!GRID_ZIPS || !GRID_ZIPS.packed) return null;
  let lo = 0, hi = GRID_ZIPS.n - 1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const at = GRID_ZIPS.packed.substr(mid * 10, 5);
    if (at === zip) return GRID_ZIPS.packed.substr(mid * 10 + 5, 5);
    if (at < zip) lo = mid + 1; else hi = mid - 1;
  }
  return null;
}

function onZipInput(input) {
  const zip = input.value.replace(/\D/g, '').slice(0, 5);
  input.value = zip;
  const card = document.getElementById('grid-card');
  const err  = document.getElementById('zip-error');
  const next = document.getElementById('next-zip');
  S.zip = ''; S.grid = null;
  card.classList.remove('visible');
  err.classList.remove('visible');
  if (next) next.textContent = 'Skip →';
  if (zip.length < 5) { saveSelections(); return; }

  const finish = () => {
    const fips = countyForZip(zip);
    const county = fips && GRID_SC && GRID_SC.counties && GRID_SC.counties[fips];
    if (!county) { err.classList.add('visible'); return; }
    S.zip = zip;
    S.grid = county;
    renderGridCard(county);
    if (next) next.textContent = 'Next step →';
    saveSelections();
  };
  if (GRID_ZIPS && GRID_SC) finish();
  else if (gridFetch) gridFetch.then(finish);
  else err.classList.add('visible');
}

function renderGridCard(g) {
  const county = g.name ? g.name + ' County' : 'Your county';
  document.getElementById('grid-card-eyebrow').innerHTML = ICONS.pin + ' ' + county + (g.st ? ', ' + g.st : '');
  document.getElementById('grid-card-title').textContent = g.util
    ? (g.utilShare ? g.util + ' powers about ' + g.utilShare + '% of your county' : g.util + ' serves your area')
    : "Here's what your grid looks like";
  const stats = [];
  if (g.oh != null)  stats.push({icon: ICONS.seamless, v: fmt1(g.oh) + ' hrs', l: 'without power in a typical year'});
  if (g.len != null) stats.push({icon: ICONS.rates,    v: '~' + fmt1(g.len) + ' hrs', l: 'length of a typical outage'});
  if (g.pcr != null && g.pcr > 0) stats.push({icon: ICONS.bulb, v: '+' + fmt1(g.pcr) + '%', l: 'rate increase since 2019, after inflation'});
  document.getElementById('grid-card-stats').innerHTML = stats.map(s =>
    '<div class="grid-stat"><span class="grid-stat-icon">' + s.icon + '</span><span class="grid-stat-value">' + s.v + '</span><span class="grid-stat-label">' + s.l + '</span></div>'
  ).join('');
  requestAnimationFrame(() => requestAnimationFrame(() =>
    document.getElementById('grid-card').classList.add('visible')));
}

function fmt1(n) { return Math.round(n * 10) % 10 === 0 ? String(Math.round(n)) : (Math.round(n * 10) / 10).toFixed(1); }

/* ── STEP 1: ROOMS ── */
function toggleRoom(card) {
  const v = card.dataset.value;
  S.rooms.has(v) ? (S.rooms.delete(v), card.classList.remove('selected')) : (S.rooms.add(v), card.classList.add('selected'));
  document.getElementById('next-step1').disabled = S.rooms.size === 0;
  document.getElementById('edu-rooms').classList.toggle('visible', S.rooms.size > 0);
  syncPressed('#rooms-options');
  saveSelections();
}

/* ── STEP 2: HIGH-DRAW ── */
function toggleHighdraw(card) {
  const v = card.dataset.value;
  if (S.highdraw.has('none')) {
    S.highdraw.delete('none');
    document.getElementById('highdraw-none').classList.remove('selected');
  }
  S.highdraw.has(v) ? (S.highdraw.delete(v), card.classList.remove('selected')) : (S.highdraw.add(v), card.classList.add('selected'));
  document.getElementById('next-step2').disabled = S.highdraw.size === 0;
  syncPressed('#highdraw-options');
  saveSelections();
}
function toggleHighdrawNone(card) {
  document.querySelectorAll('#highdraw-options .option-card:not(#highdraw-none)').forEach(c => c.classList.remove('selected'));
  S.highdraw.clear();
  if (card.classList.contains('selected')) {
    card.classList.remove('selected');
  } else {
    card.classList.add('selected');
    S.highdraw.add('none');
  }
  document.getElementById('next-step2').disabled = S.highdraw.size === 0;
  syncPressed('#highdraw-options');
  saveSelections();
}

/* ── STEP 3: PRIORITIES — multi-select ── */
function togglePriority(card) {
  if (!card || !card.dataset) return;
  // Guard: ensure priorities is always a Set (defensive against stale cached JS)
  if (!S.priorities || !(S.priorities instanceof Set)) S.priorities = new Set();
  const v = card.dataset.value;
  if (!v) return;
  if (S.priorities.has(v)) {
    S.priorities.delete(v);
    card.classList.remove('selected');
  } else {
    S.priorities.add(v);
    card.classList.add('selected');
  }
  const btn = document.getElementById('next-step3');
  if (btn) btn.disabled = S.priorities.size === 0;
  syncPressed('#priority-options');
  saveSelections();
}

/* ── LOADING ── */
function showLoading() {
  goTo('loading');

  // Restart fill animation via class toggle (avoids !important inline style conflict)
  const ring = document.getElementById('pila-loading-ring');
  if (ring) {
    ring.classList.remove('is-animating');
    void ring.getBoundingClientRect(); // force reflow
    ring.classList.add('is-animating');
  }

  const rooms    = [...S.rooms].map(r  => ({icon: ROOM_ICONS[r],    label: ROOM_LABELS[r]}));
  const hd       = [...S.highdraw].filter(v => v !== 'none').map(h => ({icon: HD_ICONS[h],     label: HD_LABELS[h]}));

  // Grid rows first — when we know the county, the loading screen is doing
  // real, visibly personal work rather than generic theater.
  const gridRows = [];
  if (S.grid && S.grid.util) gridRows.push({icon: ICONS.pin, label: `Checking ${S.grid.util} territory`});
  if (S.grid && S.grid.name) gridRows.push({icon: ICONS.seamless, label: `Analyzing outages in ${S.grid.name} County`});

  const allItems = [...gridRows, ...rooms, ...hd];

  // Build rows: grid + one per space/appliance, then one per selected priority
  const rows = allItems.map(it => ({icon: it.icon, label: it.label, considering: false}));
  S.priorities.forEach(p => {
    rows.push({icon: PRIORITY_ICONS[p] || ICONS.spark, label: `Considering ${PRIORITY_LABELS[p] || p}…`, considering: true});
  });

  const container = document.getElementById('loading-rows');
  container.innerHTML = '';
  const els = rows.map(r => {
    const el = document.createElement('div');
    el.className = 'loading-row' + (r.considering ? ' considering' : '');
    el.innerHTML = `<span class="loading-row-icon">${r.icon}</span>${r.label}`;
    container.appendChild(el);
    return el;
  });

  // Stagger space rows across first ~3s; priority rows appear at 3.6s+
  const spaceRows      = rows.filter(r => !r.considering);
  const priorityRows   = rows.filter(r => r.considering);
  const stagger        = spaceRows.length > 1 ? Math.min(440, 2400 / Math.max(spaceRows.length - 1, 1)) : 0;

  els.forEach((el, i) => {
    const r = rows[i];
    let delay;
    if (!r.considering) {
      const spaceIdx = spaceRows.indexOf(r);
      delay = 260 + spaceIdx * stagger;
    } else {
      const priIdx = priorityRows.indexOf(r);
      delay = 3600 + priIdx * 300;
    }
    setTimeout(() => el.classList.add('visible'), delay);
  });

  setTimeout(() => { buildResults(); goTo('results'); }, 5300);
}

/* ── RESULTS ENGINE ── */
function buildResults() {
  const rooms    = [...S.rooms];
  const highdraw = [...S.highdraw].filter(v => v !== 'none');
  const batteryCount = Math.max(1, Math.min(rooms.length + highdraw.length, 6));

  S.upsellQty = 1;

  const zones = [
    ...rooms.map(r   => ({key: r, label: ROOM_LABELS[r],  icon: ROOM_ICONS[r]})),
    ...highdraw.map(h => ({key: h, label: HD_LABELS[h],   icon: HD_ICONS[h]}))
  ].slice(0, batteryCount);
  if (zones.length === 0) zones.push({key:'home', label:'Home', icon:ICONS.home});

  S.batteries = zones.map((z, i) => ({
    ...z,
    idx: i,
    expansion: false,
    color: i % 2 === 0 ? 'white' : 'black',   // ← was: 'white'
    mount: (z.key === 'bedroom' || z.key === 'office') ? 'stand'
        : (z.key === 'sump'    || z.key === 'furnace') ? 'wall'
        : 'flat'
  }));

  recalcPrice();
  updateAccessoryChips();
  renderBatteryVisual();
  renderBatteryRows();

  // Backup chart
  const bd = buildBackupData(rooms, highdraw);
  const mx = Math.max(...bd.map(b => b.hrs));
  document.getElementById('backup-times-list').innerHTML = bd.map(b => `
    <div class="backup-row">
      <div class="backup-appliance">${b.icon} ${b.label}</div>
      <div class="backup-bar-wrap"><div class="backup-bar" data-pct="${Math.round(b.hrs/mx*100)}"></div></div>
      <div class="backup-time">${b.hrs} hrs</div>
    </div>`).join('');

  // Grid note — frame the backup window against the user's actual county
  const gn = document.getElementById('backup-grid-note');
  if (gn) {
    if (S.grid && S.grid.len != null) {
      const minHrs = Math.min(...bd.map(b => b.hrs));
      const mult = Math.floor(minHrs / Math.max(S.grid.len, 0.1));
      gn.innerHTML = ICONS.pin + `<span>A typical outage in ${S.grid.name} County lasts about <strong>${fmt1(S.grid.len)} hours</strong>.` +
        (mult >= 2 ? ` Your shortest backup window above is ${mult}× that.` : '') + '</span>';
    } else {
      gn.innerHTML = ''; /* :empty rule hides it */
    }
  }

  // Double rAF ensures DOM is painted before triggering scaleX transition
  requestAnimationFrame(() => requestAnimationFrame(() => {
    document.querySelectorAll('#pila-configurator-panel .backup-bar').forEach(b => {
      b.style.transform = 'scaleX(' + (b.dataset.pct / 100) + ')';
    });
  }));

  // Upsell headline
  const hasExpand = S.priorities.has('seamless');
  document.getElementById('upsell-headline').innerHTML = hasExpand
    ? '<em>Double your backup time.</em> Add an Expansion Battery.'
    : 'More coverage, more peace of mind.';
  document.getElementById('upsell-price').textContent = `$${pExpPrice(S.batteries[0]?.color || 'white').toLocaleString()} per battery`;
  S.upsellQty = 1;
  updateUpsellQtyUI();
}

/* ── PRICE CALC ── */
function recalcPrice() {
  const n = S.batteries.length;
  const hasFridgeSpace = S.batteries.some(b => b.key==='kitchen' || b.key==='garage') || S.priorities.has('fridge');
  const wallCount  = S.batteries.filter(b => b.mount==='wall').length;
  const standCount = S.batteries.filter(b => b.mount==='stand').length;
  const expCount   = S.batteries.filter(b => b.expansion).length;
  const total = S.batteries.reduce((sum, b) => sum + pPrice(b.color) + (b.expansion ? pExpPrice(b.color) : 0), 0)
    + (hasFridgeSpace ? pFridgePrice() : 0)
    + wallCount * pWallPrice()
    + standCount * pStandPrice();
  // Add-ons only. The battery count is already in the setup name, and the
  // Fridge Sensor Kit is priced in silently unless we say so here.
  const parts = [];
  if (expCount > 0)   parts.push(`Expansion Battery${expCount > 1 ? ' ×'+expCount : ''}`);
  if (wallCount > 0)  parts.push(`Wall Mount Kit${wallCount > 1 ? ' ×'+wallCount : ''}`);
  if (standCount > 0) parts.push(`Vertical Stand${standCount > 1 ? ' ×'+standCount : ''}`);
  if (hasFridgeSpace) parts.push('Fridge Sensor Kit');
  // Shop Pay Installments: monthly financing runs up to 12 months; show the
  // 12-month figure as an estimate (exact terms come from Shop Pay at checkout).
  const monthly = Math.ceil(total / 12);
  // Use Shopify's rendered logo unless the filter fell back to its generic
  // card icon (which it does for an unrecognized payment type).
  const spTpl = document.getElementById('pila-shoppay-logo');
  const spHtml = spTpl ? spTpl.innerHTML.trim() : '';
  const spLogo = (spHtml && !/generic/i.test(spHtml)) ? spHtml : '<span class="shoppay-badge">Shop Pay</span>';
  const priceEl = document.getElementById('primary-price');
  priceEl.innerHTML =
    `$${total.toLocaleString()}` +
    `<div class="price-shoppay">From about $${monthly.toLocaleString()}/mo with <span class="shoppay-logo">${spLogo}</span><span class="price-shoppay-est">Exact terms at checkout.</span></div>` +
    (parts.length ? `<div class="price-detail">Includes ${parts.join(' · ')}</div>` : '');
  priceEl.classList.remove('price-pulse');
  void priceEl.offsetWidth; // restart pulse animation
  priceEl.classList.add('price-pulse');
  const configName = n===1?'Starter Setup':n===2?'Essentials Setup':n<=4?'Whole-Home Setup':'Extended Resilience Setup';
  document.getElementById('primary-name').textContent = `${n}-Battery ${configName}`;
}

function updateAccessoryChips() { /* chips removed — info now lives in price detail line */ }

/* ── BATTERY VISUAL — flat overlapping deck ── */
function renderBatteryVisual() {
  const v = document.getElementById('primary-visual');
  v.innerHTML = '';
  const shown = S.batteries.slice(0, 5);
  const n = shown.length;

  const CARD_W = 130;
  // ≤3 batteries: spread with positive gap; >3: overlap to fit
  const OVERLAP = n <= 1 ? 0 : n <= 3 ? -14 : Math.min(40, Math.max(20, Math.round((n * CARD_W - 320) / (n - 1))));

  const deck = document.createElement('div');
  deck.style.cssText = 'display:flex;align-items:flex-start;flex-shrink:0;';

  shown.forEach((b, i) => {
    const card = document.createElement('div');
    card.className = `result-battery-card color-${b.color}`;
    card.id = `vis-batt-${b.idx}`;
    card.style.cssText = [
      `width:${CARD_W}px`,
      `flex-shrink:0`,
      `position:relative`,
      `z-index:${i + 1}`,
      i > 0 ? `margin-left:-${OVERLAP}px` : '',
    ].filter(Boolean).join(';') + ';';

    const imgSrc = window.PILA_BATTERY_IMAGES?.[b.color] || window.PILA_PRODUCTS?.battery?.[b.color]?.image;
    if (imgSrc) {
      const imgEl = document.createElement('img');
      imgEl.src = imgSrc;
      imgEl.alt = '';
      imgEl.style.cssText = 'width:100%;height:auto;display:block;';
      card.appendChild(imgEl);
    } else {
      const fallback = document.createElement('div');
      fallback.style.cssText = `width:${CARD_W}px;height:${Math.round(CARD_W*1.2)}px;background:${COLOR_BG[b.color]};border-radius:8px;`;
      card.appendChild(fallback);
    }
    deck.appendChild(card);
  });

  v.appendChild(deck);

  if (S.batteries.length > 5) {
    const m = document.createElement('div');
    m.style.cssText = 'font-family:var(--font-mono);font-size:10px;color:#999999;margin-top:10px;text-align:center;width:100%;';
    m.textContent = `+${S.batteries.length - 5} more`;
    v.appendChild(m);
  }
}

/* ── PER-BATTERY ROWS ── */
function renderBatteryRows() {
  const canDelete = S.batteries.length > 1;
  document.getElementById('battery-rows').innerHTML = S.batteries.map((b, i) => `
    <div class="battery-row" id="brow-${i}">
      <div class="battery-row-header">
        <div class="battery-row-icon" id="brow-icon-${i}" style="background:${COLOR_BG[b.color]};color:${b.color==='black'?'#FFFFFF':'#111111'}">${b.icon}</div>
        <div style="flex:1;min-width:0;">
          <div class="battery-row-name">Battery ${i+1} — ${b.label}</div>
          <div class="battery-row-sub" id="brow-sub-${i}">${mountLabel(b.mount)} · ${COLOR_LABELS[b.color]}</div>
        </div>
        ${canDelete ? `<button class="brow-delete" onclick="confirmRemoveBattery(${i})" title="Remove battery ${i+1}" aria-label="Remove battery ${i+1}">${ICONS.trash}</button>` : ''}
      </div>
      <div class="color-swatches" style="align-items:center;">
        ${COLORS.map(c => `<div class="color-swatch swatch-${c}${b.color===c?' selected':''}" title="${COLOR_LABELS[c]}" onclick="setBatteryColor(${i},'${c}')"></div>`).join('')}
        <span class="color-swatch-label" id="brow-colorlabel-${i}">${COLOR_LABELS[b.color]}</span>
      </div>
      <div class="mount-options" id="brow-mounts-${i}">
        ${MOUNTS.map(m => `<div class="mount-option${b.mount===m.value?' selected':''}" data-mount="${m.value}" onclick="setBatteryMount(${i},'${m.value}')"><div class="mount-option-dot"></div>${m.label}</div>`).join('')}
      </div>
      <div class="mount-options" style="margin-top:8px;">
        <div class="mount-option${b.expansion?' selected':''}" id="brow-exp-${i}" onclick="toggleExpansion(${i})"><div class="mount-option-dot"></div>Add Expansion Battery (+$${pExpPrice(b.color).toLocaleString()})</div>
      </div>
      <div class="mount-note">Doubles this Pila from 1.6 to 3.2 kWh. You can also add one later.</div>
    </div>`).join('');
  updateConfigSummaryLine();
}

function mountLabel(m) { return {flat:'Flat', stand:'Vertical Stand', wall:'Wall Mount'}[m]; }
function mountNote(m)  { return {flat:'No accessory needed', stand:`Includes Vertical Stand Kit ($${pStandPrice()})`, wall:`Includes Wall Mounting Kit ($${pWallPrice()})`}[m]; }

/* ── SET COLOR ── */
function setBatteryColor(idx, color) {
  S.batteries[idx].color = color;
  document.querySelectorAll(`#brow-${idx} .color-swatch`).forEach(s => {
    s.classList.toggle('selected', COLORS.some(c => c===color && s.classList.contains('swatch-'+c)));
  });
  const browIcon = document.getElementById(`brow-icon-${idx}`);
  browIcon.style.background = COLOR_BG[color];
  browIcon.style.color = color === 'black' ? '#FFFFFF' : '#111111';
  const vis = document.getElementById(`vis-batt-${idx}`);
  if (vis) {
    COLORS.forEach(c => vis.classList.remove('color-' + c));
    vis.classList.add('color-' + color);
    // vis.style.background = COLOR_BG[color];  ← remove this line
    const img = vis.querySelector('img');
    const newSrc = window.PILA_BATTERY_IMAGES?.[color] || window.PILA_PRODUCTS?.battery?.[color]?.image;
    if (img && newSrc && img.src !== newSrc) {
      // Crossfade instead of a hard src swap
      img.style.transition = 'opacity 0.16s ease';
      img.style.opacity = '0';
      setTimeout(function() {
        img.onload = function() { img.style.opacity = '1'; img.onload = null; };
        img.src = newSrc;
        if (img.complete) { img.style.opacity = '1'; img.onload = null; }
      }, 160);
    }
  }
  const expEl = document.getElementById(`brow-exp-${idx}`);
  if (expEl) expEl.innerHTML = `<div class="mount-option-dot"></div>Add Expansion Battery (+$${pExpPrice(color).toLocaleString()})`;
  recalcPrice();
  document.getElementById(`brow-sub-${idx}`).textContent = `${mountLabel(S.batteries[idx].mount)} · ${COLOR_LABELS[color]}`;
  document.getElementById(`brow-colorlabel-${idx}`).textContent = COLOR_LABELS[color];
  updateConfigSummaryLine();
}

/* ── SET MOUNT ── */
function setBatteryMount(idx, mount) {
  S.batteries[idx].mount = mount;
  document.querySelectorAll(`#brow-mounts-${idx} .mount-option`).forEach(opt => {
    opt.classList.toggle('selected', opt.dataset.mount === mount);
  });
  document.getElementById(`brow-sub-${idx}`).textContent = `${mountLabel(mount)} · ${COLOR_LABELS[S.batteries[idx].color]}`;
  updateConfigSummaryLine();
  updateAccessoryChips();
  recalcPrice();
}

function updateConfigSummaryLine() { /* static label */ }

/* ── PER-BATTERY EXPANSION ── */
function toggleExpansion(idx) {
  S.batteries[idx].expansion = !S.batteries[idx].expansion;
  const el = document.getElementById(`brow-exp-${idx}`);
  if (el) el.classList.toggle('selected', S.batteries[idx].expansion);
  recalcPrice();
}

/* ── DELETE BATTERY ── */
let pendingDeleteIdx = null;
function confirmRemoveBattery(idx) {
  pendingDeleteIdx = idx;
  const b = S.batteries[idx];
  document.getElementById('confirm-modal-title').textContent = `Remove ${b.label} battery?`;
  document.getElementById('confirm-remove-btn').onclick = executeBatteryRemove;
  document.getElementById('confirm-modal-overlay').classList.add('open');
}
function executeBatteryRemove() {
  if (pendingDeleteIdx === null) return;
  S.batteries.splice(pendingDeleteIdx, 1);
  S.batteries.forEach((b, i) => b.idx = i);
  S.upsellQty = Math.min(S.upsellQty, S.batteries.length);
  closeConfirmModal();
  renderBatteryVisual();
  renderBatteryRows();
  updateAccessoryChips();
  recalcPrice();
  updateUpsellQtyUI();
}
function closeConfirmModal(e) {
  if (e && e.target !== document.getElementById('confirm-modal-overlay')) return;
  document.getElementById('confirm-modal-overlay').classList.remove('open');
  pendingDeleteIdx = null;
}

/* ── ACCORDION ── */
let configOpen = false;
function toggleConfig() {
  configOpen = !configOpen;
  document.getElementById('config-body').classList.toggle('open', configOpen);
  document.getElementById('config-chevron').classList.toggle('open', configOpen);
}

/* ── BACKUP DATA ── */
function buildBackupData(rooms, highdraw) {
  const d = [];
  if (rooms.includes('kitchen')||rooms.includes('garage')) d.push({icon:ICONS.fridge, label:'Refrigerator', hrs:32});
  if (rooms.includes('office')||rooms.includes('living'))  d.push({icon:ICONS.wifi, label:'WiFi / Router', hrs:132});
  if (rooms.includes('bedroom')||rooms.includes('living')) d.push({icon:ICONS.bulb, label:'LED Lights', hrs:158});
  if (rooms.includes('living'))  d.push({icon:ICONS.tv, label:'TV', hrs:32});
  if (rooms.includes('office'))  d.push({icon:ICONS.office, label:'Laptop', hrs:23});
  if (rooms.includes('bedroom')) d.push({icon:ICONS.wind, label:'Air Purifier', hrs:40});
  if (rooms.includes('garage'))  d.push({icon:ICONS.door, label:'Garage Door', hrs:48});
  if (highdraw.includes('ac'))       d.push({icon:ICONS.ac, label:'Window A/C', hrs:6});
  if (highdraw.includes('furnace'))  d.push({icon:ICONS.furnace, label:'Gas Furnace', hrs:24});
  if (highdraw.includes('sump'))     d.push({icon:ICONS.sump, label:'Sump Pump', hrs:12});
  if (highdraw.includes('aquarium')) d.push({icon:ICONS.aquarium, label:'Aquarium', hrs:79});
  if (d.length === 0) d.push({icon:ICONS.simplicity, label:'Typical appliances', hrs:32});
  return d.slice(0, 5);
}

/* ── UPSELL QTY ── */
function changeUpsellQty(delta) {
  S.upsellQty = Math.max(1, Math.min(S.batteries.length, S.upsellQty + delta));
  updateUpsellQtyUI();
}
function updateUpsellQtyUI() {
  const n   = S.batteries.length;
  const el  = document.getElementById('upsell-qty-display');
  const dec = document.getElementById('upsell-qty-dec');
  const inc = document.getElementById('upsell-qty-inc');
  if (el)  el.textContent      = S.upsellQty;
  if (dec) dec.style.opacity   = S.upsellQty <= 1 ? '0.3' : '1';
  if (inc) inc.style.opacity   = S.upsellQty >= n ? '0.3' : '1';
}
function addUpsellToCart() {
  const btn = document.querySelector('#pila-configurator-panel .btn-cart-upsell');
  const orig = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  const items = [];
  for (let i = 0; i < S.upsellQty; i++) {
    const color = S.batteries[i]?.color || S.batteries[0]?.color || 'white';
    const id = window.PILA_PRODUCTS?.expansion?.[color]?.id;
    if (id) items.push({ id, quantity: 1,
      properties: { 'Expansion for': S.batteries[i]?.label || 'Battery ' + (i+1) }
    });
  }
  if (!items.length) { if (btn) { btn.disabled = false; btn.innerHTML = orig; } return; }
  postToCart(items, btn, orig);
}

/* ── ADD TO CART ── */
function addToCart() {
  const btn = document.querySelector('#pila-configurator-panel .btn-cart-main');
  const orig = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  const items = [];
  S.batteries.forEach(b => {
    const id = window.PILA_PRODUCTS?.battery?.[b.color]?.id;
    if (id) items.push({ id, quantity: 1 });
    if (b.expansion) {
      const eid = window.PILA_PRODUCTS?.expansion?.[b.color]?.id;
      if (eid) items.push({ id: eid, quantity: 1, properties: { 'Expansion for': b.label } });
    }
    if (b.mount === 'wall') {
      const wid = window.PILA_PRODUCTS?.wall?.id;
      if (wid) items.push({ id: wid, quantity: 1 });
    }
    if (b.mount === 'stand') {
      const sid = window.PILA_PRODUCTS?.stand?.id;
      if (sid) items.push({ id: sid, quantity: 1 });
    }
  });
  const hasFridge = S.batteries.some(b => b.key==='kitchen'||b.key==='garage') || S.priorities.has('fridge');
  if (hasFridge) {
    const fid = window.PILA_PRODUCTS?.fridge?.id;
    if (fid) items.push({ id: fid, quantity: 1 });
  }
  if (!items.length) { if (btn) { btn.disabled = false; btn.innerHTML = orig; } return; }
  postToCart(items, btn, orig);
}

/* ── SHARED CART POST ── */
function showCartError(msg) {
  const el = document.getElementById('cart-error');
  if (el) el.textContent = msg || '';
}
function postToCart(items, btn, origHTML) {
  showCartError('');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      console.error('Cart error:', data.description);
      showCartError("We couldn't add that to your cart. Try again, or tap Get help below.");
      if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    pilaCloseConfigurator();
    setTimeout(function() {
      window.location = '/cart';
    }, 450);
  })
  .catch(function() {
    showCartError("We couldn't reach the cart. Check your connection and try again.");
    if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
  });
}

/* ── RETAKE ── */
function retakeQuiz() {
  S.rooms.clear();
  S.highdraw.clear();
  S.priorities.clear();
  S.batteries = [];
  S.upsellQty = 1;
  S.zip = ''; S.grid = null;
  const zi = document.getElementById('zip-input');
  if (zi) zi.value = '';
  document.getElementById('grid-card')?.classList.remove('visible');
  document.getElementById('zip-error')?.classList.remove('visible');
  const nz = document.getElementById('next-zip');
  if (nz) nz.textContent = 'Skip →';
  try { sessionStorage.removeItem(PERSIST_KEY); } catch (e) {}
  document.querySelectorAll('#pila-configurator-panel .option-card').forEach(c => c.setAttribute('aria-pressed', 'false'));
  showCartError('');
  document.querySelectorAll('#pila-configurator-panel .option-card').forEach(c => c.classList.remove('selected'));
  document.querySelectorAll('#pila-configurator-panel [id^="next-step"]').forEach(b => b.disabled = true);
  document.getElementById('edu-rooms').classList.remove('visible');
  configOpen = false;
  // Remove animation class so it can restart next time
  const ring = document.getElementById('pila-loading-ring');
  if (ring) ring.classList.remove('is-animating');
  goTo('intro');
}